import { CONTENT_WIDTH, bottomMarginItemGlobal } from "../../utils/pdfConstants";


export function renderRiskBlock({ content, riskidata = [], contentWidth = CONTENT_WIDTH, reportType }) {
  if (!riskidata || riskidata.length === 0) {
    content.push({
      text: "Ei riskitietoja saatavilla.",
      style: "paragraph",
      bold: true,
      margin: [0, 5, 0, 10],
    });
    return;
  }

  const riskColorMap = {
    low: "#04aa00", 1: "#04aa00",
    medium: "#d0c407", 2: "#d0c407",
    high: "#ba3b46", 3: "#ba3b46"
  };

  // Intro paragraph — TDD reports don't otherwise use a separate
  // "kuntoluokitus" (condition rating) system, so "Kuntoluokituksen
  // lisäksi" ("in addition to the condition rating") doesn't fit there;
  // for those, the sentence starts directly at "Käytämme kansainvälisesti".
  content.push({
    text: [
      reportType === "TDD"
        ? "Käytämme kansainvälisesti tunnettua liikennevalomalliin perustuvaa riskiluokitusta. Riskiluokitus on alla olevan mukainen:"
        : "Kuntoluokituksen lisäksi käytämme kansainvälisesti tunnettua liikennevalomalliin perustuvaa riskiluokitusta. Riskiluokitus on alla olevan mukainen:",
    ],
    style: "paragraph"
  });

  // Risk legend columns
  content.push({
    columns: [
      {
        width: '*',
        alignment: 'left',
        text: [
          { text: "√  ", color: "#04aa00", bold: true },
          { text: "Matala riski" },
        ],
        margin: [bottomMarginItemGlobal, 0, 0, 0],
        style: "paragraph",
      },
      {
        width: '*',
        alignment: 'center',
        text: [
          { text: "√  ", color: "#d0c407", bold: true },
          { text: "Keskitason riski" }
        ],
        style: "paragraph",
      },
      {
        width: '*',
        alignment: 'right',
        text: [
          { text: "√  ", color: "#ba3b46", bold: true },
          { text: "Korkea riski" }
        ],
        margin: [0, 0, bottomMarginItemGlobal, 0],
        style: "paragraph",
      }
    ],
    columnGap: 10
  });

  const tableLayout = {
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    paddingLeft: () => 4,
    paddingRight: () => 4,
    paddingTop: () => 0,
    paddingBottom: () => 0,
  };

  // Group by category
  const grouped = riskidata.reduce((acc, item) => {
    (acc[item.category] ||= []).push(item);
    return acc;
  }, {});

  for (const [category, items] of Object.entries(grouped)) {
    const tableBody = items.map(item => {
      const hasRisk = !!item.risk;
      const mark = hasRisk ? "√" : "—";
      const color = hasRisk ? riskColorMap[item.risk] || "black" : "#999";
      const desc = hasRisk ? (item.description || "") : "";

      return [
        { text: item.label, style: "paragraph", bold: true, alignment: "left", margin: [0, 2, 0, 0] },
        {
          columns: [
            { text: mark, style: "paragraph", color, bold: true, width: 18, alignment: "center", margin: [0, 3, 0, 0] },
            { text: desc, style: "paragraph", color: hasRisk ? "black" : "#777", width: "*", alignment: "left", margin: [20, 2, 0, 0] },
          ],
          columnGap: 6,
        },
      ];
    });

    content.push({
      stack: [
        {
          columns: [
            { text: category.toUpperCase(), style: "paragraph", bold: true, width: "30%", margin: [0, 4, 0, 0] },
            { text: "Riski", style: "paragraph", bold: true, alignment: "left", width: "70%", margin: [0, 4, 0, 0] }
          ]
        },
        {
          canvas: [
            { type: "line", x1: 0, y1: 0, x2: contentWidth, y2: 0, lineWidth: 1, lineColor: "#198754" },
          ],
          margin: [0, 2, 0, 4],
        },
        {
          table: { widths: ["30%", "70%"], body: tableBody },
          layout: tableLayout,
          margin: [0, 0, 0, 4],
        },
      ],
      unbreakable: true,
    });
  }
}
